import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../theme/palette";

import { View } from "../Base";

const useStyles = makeStyles(() => ({
  label: {
    width: "2.5rem",
    height: "1.25rem",
    lineHeight: "1.25rem",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    marginBottom: "9px",
    position: "relative",
  },
  shape: {
    position: "absolute",
    width: "0.25rem",
    height: "0.25rem",
    borderWidth: "0 0.094rem 0.094rem 0",
    borderColor: "white",
    borderStyle: "solid",
    bottom: "0.125rem",
    right: "0.125rem",
  },
}));

const LocationLabel = ({ location }) => {
  const styles = useStyles();
  return (
    <View
      style={{
        background: location.colour || palette.translucentBlack,
        color: location?.textColour || palette.typography.white.high,
        display: "inline-block",
      }}
      className={styles.label}
    >
      {location.locationCode}
      <View className={styles.shape} />
    </View>
  );
};

export default LocationLabel;
